const romeFormatter = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
});

export function romeAppointmentFields(timestamp: number) {
  const parts = Object.fromEntries(romeFormatter.formatToParts(timestamp).map((part) => [part.type, part.value]));
  return { date: `${parts.year}-${parts.month}-${parts.day}`, time: `${parts.hour}:${parts.minute}` };
}

/** Convert the Italian appointment entered by the operator to an actual instant. */
export function parseRomeAppointment(date: string, time: string, now = Date.now()): number {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(time)) {
    throw new Error('Seleziona una data e un’ora di consegna valide.');
  }
  const wallTime = Date.parse(`${date}T${time}:00Z`);
  if (!Number.isFinite(wallTime)) throw new Error('Data di consegna non valida.');
  let instant = wallTime;
  for (let attempt = 0; attempt < 3; attempt++) {
    const fields = romeAppointmentFields(instant);
    instant += wallTime - Date.parse(`${fields.date}T${fields.time}:00Z`);
  }
  const actual = romeAppointmentFields(instant);
  if (actual.date !== date || actual.time !== time) {
    throw new Error('Data o ora non valida nel fuso italiano. Scegli un altro orario.');
  }
  if (instant <= now) throw new Error('La consegna deve essere prevista in una data e ora future.');
  return instant;
}

export function primoUpAppointmentDate(timestamp: number, time?: string): string {
  const fields = romeAppointmentFields(timestamp);
  return `${fields.date} ${time || fields.time}:00`;
}

/** Some older requests store only a date: never infer their time from midnight. */
export function formatRequestedAppointment(appointment: { date: number; time?: string } | null | undefined): string | null {
  if (!appointment || !Number.isFinite(new Date(appointment.date).getTime())) return null;
  const date = new Intl.DateTimeFormat('it-IT', {
    timeZone: 'Europe/Rome', year: 'numeric', month: 'short', day: 'numeric',
  }).format(appointment.date);
  const time = appointment.time?.trim();
  return time && /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(time)
    ? `${date} · ore ${time}`
    : date;
}
